import { render, staticRenderFns } from "./AdItemEdit.vue?vue&type=template&id=2320a342&scoped=true"
import script from "./AdItemEdit.vue?vue&type=script&lang=js"
export * from "./AdItemEdit.vue?vue&type=script&lang=js"
import style0 from "./AdItemEdit.vue?vue&type=style&index=0&id=2320a342&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2320a342",
  null
  
)

export default component.exports